import React from "react";
import "./About.scss";

export default class About extends React.Component {
  render() {
    return (
      <section
        className="about"
        id="About"
        data-scroll-section
        aria-labelledby="contact-heading"
      >
        <div className="about-content">
          <div className="about-project">
            <p className="about-eyebrow">New Project?</p>
            <h1 className="about-heading" id="contact-heading">
              Get in touch.
            </h1>
            <p className="about-project-copy">
              If you have a new project to discuss
              <a href="mailto:contact@side-eye.com" className="email-link">
                contact@side-eye.com
              </a>
            </p>
          </div>
          <div className="about-careers">
            <h2>
              Interested in joining
              <br />
              the team?
            </h2>
            <p className="about-careers-copy">
              We're always looking for talented people.
              <br />
              Email us.
            </p>
            <a href="mailto:careers@side-eye.com" className="email-link">
              careers@side-eye.com
            </a>
            <div className="about-location">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                width="20"
                height="20"
                viewBox="0 0 256 256"
                aria-hidden="true"
              >
                <g transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)">
                  <path
                    d="M 45 0 C 27.677 0 13.584 14.093 13.584 31.416 c 0 4.818 1.063 9.442 3.175 13.773 c 2.905 5.831 11.409 20.208 20.412 35.428 l 4.385 7.417 C 42.275 89.252 43.585 90 45 90 s 2.725 -0.748 3.444 -1.966 l 4.382 -7.413 c 8.942 -15.116 17.392 -29.4 20.353 -35.309 c 0.027 -0.051 0.055 -0.103 0.08 -0.155 c 2.095 -4.303 3.157 -8.926 3.157 -13.741 C 76.416 14.093 62.323 0 45 0 z M 45 42.81 c -6.892 0 -12.5 -5.607 -12.5 -12.5 c 0 -6.893 5.608 -12.5 12.5 -12.5 c 6.892 0 12.5 5.608 12.5 12.5 C 57.5 37.202 51.892 42.81 45 42.81 z"
                    transform=" matrix(1 0 0 1 0 0) "
                    strokeLinecap="round"
                  />
                </g>
              </svg>
              <p>Los Angeles - New York</p>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
